import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import LoanAgreementsAnalytics from '@/components/loans/LoanAgreementsAnalytics';
import LoanAgreementsRecords from '@/components/loans/LoanAgreementsRecords';
import { FileCheck } from 'lucide-react';

export default function LoanAgreements() {
    return (
        <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
            <div className="mb-8">
                <div className="flex items-center gap-3 mb-2">
                    <FileCheck className="h-8 w-8" />
                    <h1 className="text-4xl font-semibold tracking-tight">Advance Agreements</h1>
                </div>
                <p className="text-muted-foreground">Signed advance agreement documents.</p>
            </div>

            <Tabs defaultValue="analytics" className="space-y-6">
                <TabsList>
                    <TabsTrigger value="analytics">Analytics</TabsTrigger>
                    <TabsTrigger value="records">Records</TabsTrigger>
                </TabsList>

                <TabsContent value="analytics">
                    <LoanAgreementsAnalytics />
                </TabsContent>

                <TabsContent value="records">
                    <LoanAgreementsRecords />
                </TabsContent>
            </Tabs>
        </div>
    );
}
